import { combineReducers, Reducer } from 'redux';
import { WidgetContainerState } from '@erecruit/modules';
import { widgetContainerReducer } from '@erecruit/modules';

import { reducer as requestPosition } from '../../components/RequestPosition';
import { reducer as matchSearch } from '../../components/MatchSearch';
import { reducer as positionSearch } from '../../components/PositionSearch';
import { reducer as positionRecord } from '../../components/PositionRecord';
import { reducer as matchRecord } from '../../components/MatchRecord';
import { reducer as shiftSearch } from '../../components/ShiftSearch';
import { reducer as shiftRecord } from '../../components/ShiftRecord';
import { reducer as addNewShift } from '../../components/AddNewShiftWizard';
import { reducer as broadcastMessages } from '../../components/BroadcastMessages';
import { reducer as problemReport } from '../../components/ProblemReport';

import { RequestPositionState } from '../../components/RequestPosition/state/reducer';
import { MatchSearchState } from '../../components/MatchSearch/state/reducer';
import { PositionSearchState } from '../../components/PositionSearch/state/reducer';
import { PositionRecordState } from '../../components/PositionRecord/state/reducer';
import { MatchRecordState } from '../../components/MatchRecord/state/reducer';
import { ShiftSearchState } from '../../components/ShiftSearch/state/reducer';
import { ShiftRecordState } from '../../components/ShiftRecord/state/reducer';
import { AddNewShiftState } from '../../components/AddNewShiftWizard/state/reducer';

import {
  reducer as notifications,
  NotificationsState,
} from '../../components/Notifications';
import { BroadcastMessagesState } from '../../components/BroadcastMessages/state/reducer';
import { ProblemReportState } from '../../components/ProblemReport/state/reducer';

export interface AppState {
  widgetContainer: WidgetContainerState;
  requestPosition: RequestPositionState;
  matchSearch: MatchSearchState;
  notifications: NotificationsState;
  positionSearch: PositionSearchState;
  positionRecord: PositionRecordState;
  matchRecord: MatchRecordState;
  shiftSearch: ShiftSearchState;
  shiftRecord: ShiftRecordState;
  addNewShift: AddNewShiftState;
  broadcastMessages: BroadcastMessagesState;
  problemReport: ProblemReportState;
}

const AppReducer: Reducer<AppState> = combineReducers({
  requestPosition,
  widgetContainer: widgetContainerReducer,
  matchSearch,
  notifications,
  positionSearch,
  positionRecord,
  matchRecord,
  shiftSearch,
  shiftRecord,
  addNewShift,
  broadcastMessages,
  problemReport,
});

export default AppReducer;
